import { useState } from "react";
import type { FaqItem } from "@/types/content";

interface FaqAccordionProps {
  items: FaqItem[];
  eyebrow?: string;
  heading?: string;
  intro?: string;
  idPrefix?: string;
}

export default function FaqAccordion({
  items,
  eyebrow = "常见问题",
  heading = "关于投稿与内容，你可能想知道",
  intro = "以下是编辑部被问得最多的问题。如果你的疑问不在其中，欢迎通过投稿页面直接联系我们。",
  idPrefix = "faq",
}: FaqAccordionProps) {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section aria-labelledby={`${idPrefix}-heading`} className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <p className="text-xs font-medium tracking-widest text-primary-600 uppercase">{eyebrow}</p>
          <h2 id={`${idPrefix}-heading`} className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            {heading}
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{intro}</p>
        </div>

        <div className="lg:col-span-8">
          <div className="border-t border-background-200">
            {items.map((item, idx) => {
              const open = openIdx === idx;
              return (
                <div key={item.q} className="border-b border-background-200">
                  <h3>
                    <button
                      type="button"
                      aria-expanded={open}
                      aria-controls={`${idPrefix}-panel-${idx}`}
                      onClick={() => setOpenIdx(open ? null : idx)}
                      className="w-full flex items-start justify-between gap-4 py-4 md:py-5 text-left cursor-pointer group"
                    >
                      <span className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                        {item.q}
                      </span>
                      <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-md bg-background-100 text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                        <i className={open ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <div id={`${idPrefix}-panel-${idx}`} className="pb-5 pr-8 soft-fade">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}